export default {"src":"/_next/static/media/badge_app_store.bbfeaae5.svg","height":40,"width":120};